export default class BenutzerprofilDto {

  constructor(json) {
    if (json) {
      this.uuid = json.uuid;
      this.role = json.role
      this.name = json.name
      this.vnbExtId = json.vnbExtId
      this.gpExtId = json.gpExtId
      this.zvvExtId = json.zvvExtId
    }
  }

}
